import { useObserver } from 'mobx-react-lite'
import React, { useRef, useState } from 'react'
import { CentricTypography } from '@core/component/CentricTypography'
import { Button, makeStyles } from '@material-ui/core'
import PopupComponent, { Header } from '@components/std-components/Popup'
import Icon from '@components/std-components/Icons'
import classNames from 'classnames'
import { EnhancedCrossIcon, LimitedEditIcon } from '@components/UI-Components/svg'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from '@components/UI-Components/PrimaryButton'

const useStyle = makeStyles(() => ({
  cellIcon: {
    display: 'flex',
    alignSelf: 'center',
    padding: 0
  },
  cursor: {
    cursor: 'pointer'
  },
  popupContainer: {
    display: 'flex',
    height: 292,
    flexDirection: 'column',
    width: 548
  },
  popupHeader: {
    display: 'flex',
    width: 548,
    padding: '24px  24px 0px  24px',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  cancelIcon: {
    height: 24
  },
  headerTypography: {
    fontSize: '0.75rem'
  },
  popupContenContainer: {
    display: 'flex',
    maxHeight: 548,
    flexDirection: 'column',
    gap: 50,
    padding: '50px 24px'
  },
  unbookSection: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  unbookSectionDesc: {
    display: 'flex',
    flexDirection: 'column',
    width: 326
  },
  bookSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  bookUnbookBtn: {
    width: 120,
    height: 34
  },
  buttonlabel: {
    textAlign: 'center',
    fontSize: '0.75rem'
  },

  disabledBtn: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  hiddenBtn: {
    display: 'none',
    width: 0,
    height: 0
  }
}))

export default function BookUnbookAllButton({
  doorName,
  handleUnBookAll,
  disabled
}): JSX.Element {
  return useObserver(function useHook() {
    const classes = useStyle()
    const [open, setOpen] = useState(false)
    const ref = useRef<any>()
    const { t } = useTranslation()
    return (
      <PopupComponent
        trigger={
          <div>
            <Icon
              className={classNames(classes.cellIcon, {
                [classes.disabledBtn]: disabled
              })}
              imageSrc={LimitedEditIcon}
            />
          </div>
        }
        ref={ref}
        disabled={disabled}
        nested={true}
        keepTooltipInside
        open={open}
        arrow={false}
        contentStyle={{
          width: 548,
          maxWidth: 548,
          height: 292,
          maxHeight: 292,
          padding: '0px 0px',
          zIndex: 3000,
          boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 10px 0px'
        }}
        onOpen={() => setOpen(true)}
        onClose={() => {
          setOpen(false)
        }}
        position='top right'
      >
        <div className={classes.popupContainer}>
          <Header>
            <div className={classes.popupHeader}>
              <CentricTypography variant='h4'>{doorName ?? ''}</CentricTypography>

              <div
                className={classNames(classes.cancelIcon, {
                  [classes.disabledBtn]: disabled
                })}
                onClick={() => {
                  if (disabled) {
                    return
                  }
                  ref?.current?.close()
                }}
              >
                <Icon
                  className={classes.cursor}
                  alt='Cancel'
                  imageSrc={EnhancedCrossIcon}
                />
              </div>
            </div>
          </Header>
          <div className={classes.popupContenContainer}>
            {/* Unbook Section */}
            <div className={classes.unbookSection}>
              <div className={classes.unbookSectionDesc}>
                <CentricTypography
                  variant='buttonDarkGrey'
                  className={classes.headerTypography}
                >
                  {t('common.label.unbookAllDoors', 'UNBOOK ALL PRODUCTS FROM DOOR')}
                </CentricTypography>
                <CentricTypography variant='body1'>
                  {t(
                    'common.label.unbookAllDoorsDescription',
                    'The entered quantity will be permanently deleted and cannot be recovered.'
                  )}
                </CentricTypography>
              </div>
              <Button className={classes.hiddenBtn} />
              <PrimaryButton
                className={classes.bookUnbookBtn}
                onClick={() => {
                  if (disabled) {
                    return
                  }
                  handleUnBookAll(true)
                }}
                disabled={disabled}
              >
                <CentricTypography variant='buttonWhite' className={classes.buttonlabel}>
                  {t('common.label.unbookAll', 'UNBOOK ALL')}
                </CentricTypography>
              </PrimaryButton>
            </div>

            <div className={classes.bookSection}>
              {/* Book Section */}
              <CentricTypography
                variant='buttonDarkGrey'
                className={classes.headerTypography}
              >
                {t('common.label.bookAllProductsToDoor', 'BOOK ALL PRODUCTS TO DOOR')}
              </CentricTypography>

              <PrimaryButton
                className={classes.bookUnbookBtn}
                onClick={() => {
                  if (disabled) {
                    return
                  }
                  handleUnBookAll(false)
                }}
                disabled={disabled}
              >
                <CentricTypography variant='buttonWhite' className={classes.buttonlabel}>
                  {t('common.label.bookAll', 'BOOK ALL')}
                </CentricTypography>
              </PrimaryButton>
            </div>
          </div>
        </div>
      </PopupComponent>
    )
  })
}
